import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { setAcpInovicePageElement, setGlJournalPageElement, setPageElement, setReportPageElement, setRequisitionPageElement, setReceiptAcpInvoicePageElement } from "../config/customize/pageElements";
/**
 * pageElements - 页面元素工具类
 * @Author: 徐昭 <zhao.xu@hand-china.com>
 * @Date: 2020/9/28 10:07
 * @LastEditTime: 2020/9/28 10:07
 * @Copyright: Copyright (c) 2020, Hand
 */

export function addReportPageElement() {
  // 报销单
  // 差旅头页面元素
  setReportPageElement('TRAVEL_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", import("../config/customize/pageElements/report/travel/TravelHeaderElement"));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))); // 差旅行程行页面元素

  setReportPageElement('TRAVEL_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", import("../config/customize/pageElements/report/travel/TravelLineElement"));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }))); // 差旅补贴页面元素

  setReportPageElement('TRAVEL_SUBSIDY_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", import("../config/customize/pageElements/report/travel/TravelSubsidyLineElement"));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }))); // 差旅住宿页面元素

  setReportPageElement('TRAVEL_STAY_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", import("../config/customize/pageElements/report/travel/TravelStayLineElement"));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }))); // 差旅住宿统报行元素

  setReportPageElement('TRAVEL_STAY_UNIFIED', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", import("../config/customize/pageElements/report/travel/TravelStayUnifiedLineElement"));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }))); // 标准头页面元素

  setReportPageElement('_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", import("../config/customize/pageElements/report/standard/StandardHeaderElement"));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }))); // 日常费用行页面元素

  setReportPageElement('STANDARD', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            return _context7.abrupt("return", import("../config/customize/pageElements/report/standard/StandardLineElement"));

          case 1:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }))); // 费用精简行

  setReportPageElement('STREAMLINED', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", import("../config/customize/pageElements/report/StreamlinedLineElement"));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }))); // 费用统报报销行

  setReportPageElement('TRAVEL_UNIFIED', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", import("../config/customize/pageElements/report/UnifiedLinedLineElement"));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }))); // 计划付款行页面元素

  setReportPageElement('STANDARD_PMT', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", import("../config/customize/pageElements/report/Schedule/Schedule"));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }))); // 计划付款Y行页面元素

  setReportPageElement('Y_SCHEDULE_PAYMENT_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", import("../config/customize/pageElements/report/Schedule/ScheduleY"));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }))); // 机票统报报销行

  setReportPageElement('TICKET_UNIFIED', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", import("../config/customize/pageElements/report/TicketUnifiedLineElement"));

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }))); // 领用头

  setReportPageElement('RECEIVE_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            return _context13.abrupt("return", import("../config/customize/pageElements/report/RecipientHeaderElement/RecipientHeaderElement"));

          case 1:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }))); // 领用行

  setReportPageElement('RECEIVE_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            return _context14.abrupt("return", import("../config/customize/pageElements/report/RecipientHeaderElement/RecipientLineElement"));

          case 1:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }))); // 杂项领用头

  setReportPageElement('RECEIVE_SUNDRY_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            return _context15.abrupt("return", import("../config/customize/pageElements/report/RecipientHeaderElement/SundryHeaderElement"));

          case 1:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }))); // 杂项领用行

  setReportPageElement('RECEIVE_SUNDRY_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            return _context16.abrupt("return", import("../config/customize/pageElements/report/RecipientHeaderElement/SundryLineElement"));

          case 1:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }))); // 其它类报销头页面元素

  setReportPageElement('OTHER_TYPES_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            return _context17.abrupt("return", import("../config/customize/pageElements/report/OtherType/OtherTypeHeaderElement"));

          case 1:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }))); // 通用报销头页面元素

  setReportPageElement('COMMON_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            return _context18.abrupt("return", import("../config/customize/pageElements/report/CommonType/CommonTypeHeaderElement"));

          case 1:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }))); // 海外费用报销单头页面元素

  setReportPageElement('OVERSEAS_FEE_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            return _context19.abrupt("return", import("../config/customize/pageElements/report/OverseasFee/OverseasFeeHeaderElement"));

          case 1:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }))); // CRM报销单头页面元素

  setReportPageElement('REP_CRM_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            return _context20.abrupt("return", import("../config/customize/pageElements/report/CRM/CrmHeaderElement"));

          case 1:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }))); // CRM报销单行页面元素

  setReportPageElement('REP_CRM_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            return _context21.abrupt("return", import("../config/customize/pageElements/report/CRM/CrmLineElement"));

          case 1:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }))); // CRM海外报销单头页面元素

  setReportPageElement('OVERSEAS_CRM_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            return _context22.abrupt("return", import("../config/customize/pageElements/report/CrmOversea/CrmOverseaHeaderElement"));

          case 1:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }))); // CRM海外报销单行页面元素

  setReportPageElement('OVERSEAS_CRM_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            return _context23.abrupt("return", import("../config/customize/pageElements/report/CrmOversea/CrmOverseaLineElement"));

          case 1:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }))); // 销售费用报销单行页面元素

  setReportPageElement('SALES_EXPENSE_REI_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            return _context24.abrupt("return", import("../config/customize/pageElements/report/SaleExpense/SaleExpenseLineElement"));

          case 1:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }))); // 知识产权行页面元素

  setReportPageElement('PROPERTY_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) {
        switch (_context25.prev = _context25.next) {
          case 0:
            return _context25.abrupt("return", import("../config/customize/pageElements/report/KnowledgeProperty/KnowledgePropertyLineElement"));

          case 1:
          case "end":
            return _context25.stop();
        }
      }
    }, _callee25);
  }))); // TPM报销单头页面元素

  setReportPageElement('REP_TPM_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) {
        switch (_context26.prev = _context26.next) {
          case 0:
            return _context26.abrupt("return", import("../config/customize/pageElements/report/TPM/TpmHeaderElement"));

          case 1:
          case "end":
            return _context26.stop();
        }
      }
    }, _callee26);
  })));
  setReportPageElement('REP_TPM_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) {
        switch (_context27.prev = _context27.next) {
          case 0:
            return _context27.abrupt("return", import("../config/customize/pageElements/report/TPM/TpmLineElement"));

          case 1:
          case "end":
            return _context27.stop();
        }
      }
    }, _callee27);
  })));
}
export function addRequisitionPageElement() {
  // 差旅头页面元素
  setRequisitionPageElement('TRAVEL_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) {
        switch (_context28.prev = _context28.next) {
          case 0:
            return _context28.abrupt("return", import("../config/customize/pageElements/requisition/travel/TravelHeaderElementProps"));

          case 1:
          case "end":
            return _context28.stop();
        }
      }
    }, _callee28);
  }))); // 标准头页面元素

  setRequisitionPageElement('REQ_HEAD', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) {
        switch (_context29.prev = _context29.next) {
          case 0:
            return _context29.abrupt("return", import("../config/customize/pageElements/requisition/standard/StandardHeaderElement"));

          case 1:
          case "end":
            return _context29.stop();
        }
      }
    }, _callee29);
  }))); // 借款申请页面元素

  setRequisitionPageElement('PAYMENT', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) {
        switch (_context30.prev = _context30.next) {
          case 0:
            return _context30.abrupt("return", import("../config/customize/pageElements/requisition/payment/PaymentLineElement"));

          case 1:
          case "end":
            return _context30.stop();
        }
      }
    }, _callee30);
  }))); // 标准行页面元素

  setRequisitionPageElement('STANDARD', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) {
        switch (_context31.prev = _context31.next) {
          case 0:
            return _context31.abrupt("return", import("../config/customize/pageElements/requisition/standard/StandardLineElement"));

          case 1:
          case "end":
            return _context31.stop();
        }
      }
    }, _callee31);
  }))); // 差旅行程行页面元素

  setRequisitionPageElement('TRAVEL_DISTANCE_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
    return _regeneratorRuntime.wrap(function _callee32$(_context32) {
      while (1) {
        switch (_context32.prev = _context32.next) {
          case 0:
            return _context32.abrupt("return", import("../config/customize/pageElements/requisition/travel/TravelDistanceLineElement"));

          case 1:
          case "end":
            return _context32.stop();
        }
      }
    }, _callee32);
  }))); // 差旅行页面元素

  setRequisitionPageElement('TRAVEL', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
    return _regeneratorRuntime.wrap(function _callee33$(_context33) {
      while (1) {
        switch (_context33.prev = _context33.next) {
          case 0:
            return _context33.abrupt("return", import("../config/customize/pageElements/requisition/travel/TravelLineElement"));

          case 1:
          case "end":
            return _context33.stop();
        }
      }
    }, _callee33);
  }))); // 差旅住宿页面元素

  setRequisitionPageElement('TRAVEL_STAY_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
    return _regeneratorRuntime.wrap(function _callee34$(_context34) {
      while (1) {
        switch (_context34.prev = _context34.next) {
          case 0:
            return _context34.abrupt("return", import("../config/customize/pageElements/requisition/travel/TravelStayLineElement"));

          case 1:
          case "end":
            return _context34.stop();
        }
      }
    }, _callee34);
  }))); // 差旅住宿页面元素

  setRequisitionPageElement('TICKET_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
    return _regeneratorRuntime.wrap(function _callee35$(_context35) {
      while (1) {
        switch (_context35.prev = _context35.next) {
          case 0:
            return _context35.abrupt("return", import("../config/customize/pageElements/requisition/ticket/TicketLineElement"));

          case 1:
          case "end":
            return _context35.stop();
        }
      }
    }, _callee35);
  }))); // 招待费用行页面元素

  setRequisitionPageElement('ENTERTAIN_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
      while (1) {
        switch (_context36.prev = _context36.next) {
          case 0:
            return _context36.abrupt("return", import("../config/customize/pageElements/requisition/entertainLine/EntertainLine"));

          case 1:
          case "end":
            return _context36.stop();
        }
      }
    }, _callee36);
  }))); // 劳保领用申请头

  setRequisitionPageElement('RECEIVE_REQ_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
      while (1) {
        switch (_context37.prev = _context37.next) {
          case 0:
            return _context37.abrupt("return", import("../config/customize/pageElements/requisition/ReceiveRequisition/RecipientHeaderElement"));

          case 1:
          case "end":
            return _context37.stop();
        }
      }
    }, _callee37);
  }))); // 劳保领用申请行

  setRequisitionPageElement('RECEIVE_REQ_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
    return _regeneratorRuntime.wrap(function _callee38$(_context38) {
      while (1) {
        switch (_context38.prev = _context38.next) {
          case 0:
            return _context38.abrupt("return", import("../config/customize/pageElements/requisition/ReceiveRequisition/RecipientLineElement"));

          case 1:
          case "end":
            return _context38.stop();
        }
      }
    }, _callee38);
  }))); // 采购申请头

  setRequisitionPageElement('REQ_PO_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
    return _regeneratorRuntime.wrap(function _callee39$(_context39) {
      while (1) {
        switch (_context39.prev = _context39.next) {
          case 0:
            return _context39.abrupt("return", import("../config/customize/pageElements/requisition/PoRequisition/PoHeaderElement"));

          case 1:
          case "end":
            return _context39.stop();
        }
      }
    }, _callee39);
  }))); // 采购申请行

  setRequisitionPageElement('REQ_PO_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
    return _regeneratorRuntime.wrap(function _callee40$(_context40) {
      while (1) {
        switch (_context40.prev = _context40.next) {
          case 0:
            return _context40.abrupt("return", import("../config/customize/pageElements/requisition/PoRequisition/PoLineElement"));

          case 1:
          case "end":
            return _context40.stop();
        }
      }
    }, _callee40);
  }))); // 考勤时间行

  setRequisitionPageElement('ATTENDANCE_TIME_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
    return _regeneratorRuntime.wrap(function _callee41$(_context41) {
      while (1) {
        switch (_context41.prev = _context41.next) {
          case 0:
            return _context41.abrupt("return", import("../config/customize/pageElements/requisition/AttendanceTime/AttendanceTimeLineElement"));

          case 1:
          case "end":
            return _context41.stop();
        }
      }
    }, _callee41);
  }))); // 行程地点行

  setRequisitionPageElement('ITINERARY_LOCATION_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
    return _regeneratorRuntime.wrap(function _callee42$(_context42) {
      while (1) {
        switch (_context42.prev = _context42.next) {
          case 0:
            return _context42.abrupt("return", import("../config/customize/pageElements/requisition/ItineraryLocation/ItineraryLocationLineElement"));

          case 1:
          case "end":
            return _context42.stop();
        }
      }
    }, _callee42);
  }))); // 仓储物流-申请头

  setRequisitionPageElement('WARE_HOUSE_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
    return _regeneratorRuntime.wrap(function _callee43$(_context43) {
      while (1) {
        switch (_context43.prev = _context43.next) {
          case 0:
            return _context43.abrupt("return", import("../config/customize/pageElements/requisition/WareHouse/WareHouseHeaderElement"));

          case 1:
          case "end":
            return _context43.stop();
        }
      }
    }, _callee43);
  }))); // 仓储物流-申请行

  setRequisitionPageElement('WARE_HOUSE_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
    return _regeneratorRuntime.wrap(function _callee44$(_context44) {
      while (1) {
        switch (_context44.prev = _context44.next) {
          case 0:
            return _context44.abrupt("return", import("../config/customize/pageElements/requisition/WareHouse/WareHouseLineElement"));

          case 1:
          case "end":
            return _context44.stop();
        }
      }
    }, _callee44);
  }))); // 知识产权-申请行

  setRequisitionPageElement('PROPERTY_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
    return _regeneratorRuntime.wrap(function _callee45$(_context45) {
      while (1) {
        switch (_context45.prev = _context45.next) {
          case 0:
            return _context45.abrupt("return", import("../config/customize/pageElements/requisition/KnowledgeProperty/KnowledgePropertyLineElement"));

          case 1:
          case "end":
            return _context45.stop();
        }
      }
    }, _callee45);
  }))); // 其它类报销头页面元素

  setRequisitionPageElement('OTHER_TYPES_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
    return _regeneratorRuntime.wrap(function _callee46$(_context46) {
      while (1) {
        switch (_context46.prev = _context46.next) {
          case 0:
            return _context46.abrupt("return", import("../config/customize/pageElements/requisition/OtherType/OtherTypeHeaderElement"));

          case 1:
          case "end":
            return _context46.stop();
        }
      }
    }, _callee46);
  }))); // 会议申请头页面元素

  setRequisitionPageElement('REQ_MEETING_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
    return _regeneratorRuntime.wrap(function _callee47$(_context47) {
      while (1) {
        switch (_context47.prev = _context47.next) {
          case 0:
            return _context47.abrupt("return", import("../config/customize/pageElements/requisition/Meeting/MeetHeaderElement"));

          case 1:
          case "end":
            return _context47.stop();
        }
      }
    }, _callee47);
  }))); // 会议申请行页面元素

  setRequisitionPageElement('REQ_MEETING_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
    return _regeneratorRuntime.wrap(function _callee48$(_context48) {
      while (1) {
        switch (_context48.prev = _context48.next) {
          case 0:
            return _context48.abrupt("return", import("../config/customize/pageElements/requisition/Meeting/MeetLineElement"));

          case 1:
          case "end":
            return _context48.stop();
        }
      }
    }, _callee48);
  }))); // 海外费用申请单头页面元素

  setRequisitionPageElement('OVERSEAS_FEE_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
    return _regeneratorRuntime.wrap(function _callee49$(_context49) {
      while (1) {
        switch (_context49.prev = _context49.next) {
          case 0:
            return _context49.abrupt("return", import("../config/customize/pageElements/requisition/OverseasFee/OverseasFeeHeaderElement"));

          case 1:
          case "end":
            return _context49.stop();
        }
      }
    }, _callee49);
  }))); // CRM营销费用申请单头页面元素

  setRequisitionPageElement('REQ_CRM_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
    return _regeneratorRuntime.wrap(function _callee50$(_context50) {
      while (1) {
        switch (_context50.prev = _context50.next) {
          case 0:
            return _context50.abrupt("return", import("../config/customize/pageElements/requisition/Crm/CrmHeaderElement"));

          case 1:
          case "end":
            return _context50.stop();
        }
      }
    }, _callee50);
  }))); // CRM营销费用申请单行页面元素

  setRequisitionPageElement('REQ_CRM_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
    return _regeneratorRuntime.wrap(function _callee51$(_context51) {
      while (1) {
        switch (_context51.prev = _context51.next) {
          case 0:
            return _context51.abrupt("return", import("../config/customize/pageElements/requisition/Crm/CrmLineElement"));

          case 1:
          case "end":
            return _context51.stop();
        }
      }
    }, _callee51);
  }))); // CRM海外申请单头页面元素

  setRequisitionPageElement('OVERSEAS_CRM_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
    return _regeneratorRuntime.wrap(function _callee52$(_context52) {
      while (1) {
        switch (_context52.prev = _context52.next) {
          case 0:
            return _context52.abrupt("return", import("../config/customize/pageElements/requisition/CrmOverseas/CrmSeaHeaderElement"));

          case 1:
          case "end":
            return _context52.stop();
        }
      }
    }, _callee52);
  }))); // CRM海外申请单行页面元素

  setRequisitionPageElement('OVERSEAS_CRM_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
    return _regeneratorRuntime.wrap(function _callee53$(_context53) {
      while (1) {
        switch (_context53.prev = _context53.next) {
          case 0:
            return _context53.abrupt("return", import("../config/customize/pageElements/requisition/CrmOverseas/CrmSeaLineElement"));

          case 1:
          case "end":
            return _context53.stop();
        }
      }
    }, _callee53);
  })));
}
export function addContractPageElement() {
  // 合同标准头元素
  setPageElement('hfins-ec-front-con', 'CONTRACT_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
    return _regeneratorRuntime.wrap(function _callee54$(_context54) {
      while (1) {
        switch (_context54.prev = _context54.next) {
          case 0:
            return _context54.abrupt("return", import("../config/customize/pageElements/contract/ContractStandardHeader"));

          case 1:
          case "end":
            return _context54.stop();
        }
      }
    }, _callee54);
  })), 'contract'); // 合同交付物行元素

  setPageElement('hfins-ec-front-con', 'OBJECT_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
      while (1) {
        switch (_context55.prev = _context55.next) {
          case 0:
            return _context55.abrupt("return", import("../config/customize/pageElements/contract/ObjectLine"));

          case 1:
          case "end":
            return _context55.stop();
        }
      }
    }, _callee55);
  })), 'contract'); // 合同附件行元素

  setPageElement('hfins-ec-front-con', 'CONTRACT_ATTACHMENT', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
    return _regeneratorRuntime.wrap(function _callee56$(_context56) {
      while (1) {
        switch (_context56.prev = _context56.next) {
          case 0:
            return _context56.abrupt("return", import("../config/customize/pageElements/contract/AttachmentLine/AttachmentLine"));

          case 1:
          case "end":
            return _context56.stop();
        }
      }
    }, _callee56);
  })), 'contract'); // 合同里程碑行元素

  setPageElement('hfins-ec-front-con', 'LANDMARK_PLANS', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
    return _regeneratorRuntime.wrap(function _callee57$(_context57) {
      while (1) {
        switch (_context57.prev = _context57.next) {
          case 0:
            return _context57.abrupt("return", import("../config/customize/pageElements/contract/LandMarkPlanLine/LandMarkPlanLine"));

          case 1:
          case "end":
            return _context57.stop();
        }
      }
    }, _callee57);
  })), 'contract'); // 合同对象行元素

  setPageElement('hfins-ec-front-con', 'CONTRACT_PARTNER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
    return _regeneratorRuntime.wrap(function _callee58$(_context58) {
      while (1) {
        switch (_context58.prev = _context58.next) {
          case 0:
            return _context58.abrupt("return", import("../config/customize/pageElements/contract/PartnerLine/PartnerLine"));

          case 1:
          case "end":
            return _context58.stop();
        }
      }
    }, _callee58);
  })), 'contract'); // 合同变更头元素

  setPageElement('hfins-ec-front-con', 'CONTRACT_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
    return _regeneratorRuntime.wrap(function _callee59$(_context59) {
      while (1) {
        switch (_context59.prev = _context59.next) {
          case 0:
            return _context59.abrupt("return", import("../config/customize/pageElements/contractChange/ContractChangeHeader"));

          case 1:
          case "end":
            return _context59.stop();
        }
      }
    }, _callee59);
  })), 'contract-change'); // 合同变更交付物行元素

  setPageElement('hfins-ec-front-con', 'OBJECT_LINES', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
    return _regeneratorRuntime.wrap(function _callee60$(_context60) {
      while (1) {
        switch (_context60.prev = _context60.next) {
          case 0:
            return _context60.abrupt("return", import("../config/customize/pageElements/contractChange/ObjectLine"));

          case 1:
          case "end":
            return _context60.stop();
        }
      }
    }, _callee60);
  })), 'contract-change'); // 合同变更附件行元素

  setPageElement('hfins-ec-front-con', 'CONTRACT_ATTACHMENT', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
    return _regeneratorRuntime.wrap(function _callee61$(_context61) {
      while (1) {
        switch (_context61.prev = _context61.next) {
          case 0:
            return _context61.abrupt("return", import("../config/customize/pageElements/contractChange/AttachmentLine/AttachmentLine"));

          case 1:
          case "end":
            return _context61.stop();
        }
      }
    }, _callee61);
  })), 'contract-change'); // 合同变更里程碑行元素

  setPageElement('hfins-ec-front-con', 'LANDMARK_PLANS', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
    return _regeneratorRuntime.wrap(function _callee62$(_context62) {
      while (1) {
        switch (_context62.prev = _context62.next) {
          case 0:
            return _context62.abrupt("return", import("../config/customize/pageElements/contractChange/LandMarkPlanLine/LandMarkPlanLine"));

          case 1:
          case "end":
            return _context62.stop();
        }
      }
    }, _callee62);
  })), 'contract-change'); // 合同变更对象行元素

  setPageElement('hfins-ec-front-con', 'CONTRACT_PARTNER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
    return _regeneratorRuntime.wrap(function _callee63$(_context63) {
      while (1) {
        switch (_context63.prev = _context63.next) {
          case 0:
            return _context63.abrupt("return", import("../config/customize/pageElements/contractChange/PartnerLine/PartnerLine"));

          case 1:
          case "end":
            return _context63.stop();
        }
      }
    }, _callee63);
  })), 'contract-change');
}
export function addAcpInovicePageElement() {
  // 应付发票头元素
  setAcpInovicePageElement('STANDARD_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
    return _regeneratorRuntime.wrap(function _callee64$(_context64) {
      while (1) {
        switch (_context64.prev = _context64.next) {
          case 0:
            return _context64.abrupt("return", import("../config/customize/pageElements/acpInvoice/AcpInvoiceDetailHeader/AcpInvoiceDetailHeader"));

          case 1:
          case "end":
            return _context64.stop();
        }
      }
    }, _callee64);
  })));
  setAcpInovicePageElement('STANDARD_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
    return _regeneratorRuntime.wrap(function _callee65$(_context65) {
      while (1) {
        switch (_context65.prev = _context65.next) {
          case 0:
            return _context65.abrupt("return", import("../config/customize/pageElements/acpInvoice/AcpInvoiceStandardLine"));

          case 1:
          case "end":
            return _context65.stop();
        }
      }
    }, _callee65);
  })));
  setAcpInovicePageElement('GROUP_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66() {
    return _regeneratorRuntime.wrap(function _callee66$(_context66) {
      while (1) {
        switch (_context66.prev = _context66.next) {
          case 0:
            return _context66.abrupt("return", import("../config/customize/pageElements/acpInvoice/AcpInvoiceGroupLine/AcpInvoiceGroupLine"));

          case 1:
          case "end":
            return _context66.stop();
        }
      }
    }, _callee66);
  })));
  setAcpInovicePageElement('SCHEDULE_LINE', function () {
    return import("../config/customize/pageElements/acpInvoice/AcpInvoicePlanLine/AcpInvoicePlanLine");
  });
}
export function addGlJournalPageElement() {
  // 总账报账单元素
  setGlJournalPageElement('TRX_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67() {
    return _regeneratorRuntime.wrap(function _callee67$(_context67) {
      while (1) {
        switch (_context67.prev = _context67.next) {
          case 0:
            return _context67.abrupt("return", import("../config/customize/pageElements/glJournal/TransactionHeader"));

          case 1:
          case "end":
            return _context67.stop();
        }
      }
    }, _callee67);
  })));
  setGlJournalPageElement('ATM_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68() {
    return _regeneratorRuntime.wrap(function _callee68$(_context68) {
      while (1) {
        switch (_context68.prev = _context68.next) {
          case 0:
            return _context68.abrupt("return", import("../config/customize/pageElements/glJournal/atmLine/AtmLine"));

          case 1:
          case "end":
            return _context68.stop();
        }
      }
    }, _callee68);
  }))); // 业务头行

  setGlJournalPageElement('BIZ_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69() {
    return _regeneratorRuntime.wrap(function _callee69$(_context69) {
      while (1) {
        switch (_context69.prev = _context69.next) {
          case 0:
            return _context69.abrupt("return", import("../config/customize/pageElements/glJournal/BusinessHeader"));

          case 1:
          case "end":
            return _context69.stop();
        }
      }
    }, _callee69);
  })));
  setGlJournalPageElement('BUSINESS_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70() {
    return _regeneratorRuntime.wrap(function _callee70$(_context70) {
      while (1) {
        switch (_context70.prev = _context70.next) {
          case 0:
            return _context70.abrupt("return", import("../config/customize/pageElements/glJournal/businessLine"));

          case 1:
          case "end":
            return _context70.stop();
        }
      }
    }, _callee70);
  }))); // 财务头行

  setGlJournalPageElement('FIN_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee71() {
    return _regeneratorRuntime.wrap(function _callee71$(_context71) {
      while (1) {
        switch (_context71.prev = _context71.next) {
          case 0:
            return _context71.abrupt("return", import("../config/customize/pageElements/glJournal/FinanceHeader"));

          case 1:
          case "end":
            return _context71.stop();
        }
      }
    }, _callee71);
  })));
  setGlJournalPageElement('FINANCE_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee72() {
    return _regeneratorRuntime.wrap(function _callee72$(_context72) {
      while (1) {
        switch (_context72.prev = _context72.next) {
          case 0:
            return _context72.abrupt("return", import("../config/customize/pageElements/glJournal/financeLine"));

          case 1:
          case "end":
            return _context72.stop();
        }
      }
    }, _callee72);
  })));
}
export function addReceiptAcpInvoicePageElement() {
  // 应付发票头元素
  setReceiptAcpInvoicePageElement('STANDARD_HEADER', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee73() {
    return _regeneratorRuntime.wrap(function _callee73$(_context73) {
      while (1) {
        switch (_context73.prev = _context73.next) {
          case 0:
            return _context73.abrupt("return", import("../config/customize/pageElements/acrReceipt/AcpInvoiceHeader"));

          case 1:
          case "end":
            return _context73.stop();
        }
      }
    }, _callee73);
  })));
  setReceiptAcpInvoicePageElement('STANDARD_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee74() {
    return _regeneratorRuntime.wrap(function _callee74$(_context74) {
      while (1) {
        switch (_context74.prev = _context74.next) {
          case 0:
            return _context74.abrupt("return", import("../config/customize/pageElements/acrReceipt/AcpInvoiceStandardLine"));

          case 1:
          case "end":
            return _context74.stop();
        }
      }
    }, _callee74);
  })));
  setReceiptAcpInvoicePageElement('GROUP_LINE', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee75() {
    return _regeneratorRuntime.wrap(function _callee75$(_context75) {
      while (1) {
        switch (_context75.prev = _context75.next) {
          case 0:
            return _context75.abrupt("return", import("../config/customize/pageElements/acrReceipt/AcpInvoiceGroupLine"));

          case 1:
          case "end":
            return _context75.stop();
        }
      }
    }, _callee75);
  })));
  setReceiptAcpInvoicePageElement('SCHEDULE_LINE', function () {
    return import("../config/customize/pageElements/acrReceipt/AcpInvoicePlanLine");
  });
}